module.exports = __webpack_public_path__ + "img/Accessoire_deco.3fa45b9.jpg";